import { Button } from 'rsuite'
import Link from 'next/link'

import SafeTranslate from '../../common/SafeTranslate'
import ChatBanner from './ChatBanner'
import RfqBanner from './RfqBanner'
import { Banner } from '../../../utils/types/misc'
import UseCaseTagList from './UseCaseTagList'
import ProductCategoryCarousel from '../../Carousels/ProductCategoryCarousel'
import { Product } from '../../../utils/types/Product'
import RecentlyViewedProductsCarousel from '../../Carousels/RecentlyViewedProductsCarousel'

import styles from '../../../styles/Banner.module.less'
import buttonStyles from '../../../styles/CustomButtons.module.less'

const banners: Banner[] = [
  // All two column banners
  {
    type: 'banner-tile-left',
    classification: 'marketing-card',
    title: 'products:Trusted by Over {{count}} Satisfied Customers',
    image: 'd24-product-feed-ordering', // Dynamic image file name is generated in ProductsList.tsx
    startRow: 4,
    startColumn: 'right-most',
    spanX: 2,
    spanY: 1,
    minimumCards: 2,
    content: () => (
      <p>
        <SafeTranslate
          i18nKey="products:Find Europe’s top-quality workwear and supplies at the best prices on Droppe"
          components={{
            strong: <strong />,
          }}
        />
      </p>
    ),
  },
  {
    type: 'banner-tile-left',
    classification: 'marketing-card',
    title: 'products:Take the Chasing out of Purchasing',
    image: 'd24-product-feed-sourcing', // Dynamic image file name is generated in ProductsList.tsx
    startRow: 8,
    startColumn: 1,
    spanX: 2,
    spanY: 1,
    minimumCards: 15,
    content: (t) => (
      <>
        <p>
          {t('products:Save resources otherwise spent managing orders and suppliers via emails, calls, and unorganized data with Droppe')}
        </p>
        <Link
          href="/"
          shallow
        >
          <Button
            appearance="ghost"
            className={`
              ${buttonStyles['button-tertiary']}
              ${buttonStyles['custom-button']}
              ${buttonStyles['button-caret']}
              ${buttonStyles['button-no-border']}
              margin-top-spacer
          `}
          >
            {t('products:Learn how it works')}
          </Button>
        </Link>
      </>
    ),
  },
  {
    type: 'banner-tile-left',
    classification: 'marketing-card',
    title: 'Request free samples',
    image: 'd24-request-free-samples',
    startRow: 17,
    startColumn: 'right-most',
    spanX: 2,
    spanY: 1,
    minimumCards: 44,
    content: () => (
      <p>
        <SafeTranslate
          i18nKey="marketing:Test first and buy later Visit any product page to request your free sample"
          components={{
            b: <b />,
          }}
        />
      </p>
    ),
  },

  // All fully expanded banners
  {
    type: 'banner',
    classification: 'marketing-card',
    title: '', // NOTE: Empty title because No title needs to be displayed for rfq banners from config.
    // This might change in the future
    startRow: 14,
    startColumn: 1,
    spanX: 'full',
    spanY: 1,
    minimumCards: 34,
    content: () => (
      <RfqBanner />
    ),
    // NOTE: Empty title because No title needs to be displayed for rfq banners from config.
    // This might change in the future
  },
  {
    type: 'banner',
    classification: 'product-carousel',
    title: '',
    startRow: 3,
    startColumn: 1,
    spanX: 'full',
    spanY: 1,
    minimumCards: 10,
    content: (t, _, products?: Product[]) => (
      <ProductCategoryCarousel
        productFeed={products || []}
        sliceRange={[0, 20]}
      />
    ),
    id: 'productCategoryCarousel',
    hideOnDevice: 'mobile',
  },
  {
    type: 'banner',
    classification: 'product-carousel',
    title: '',
    startRow: 6,
    startColumn: 1,
    spanX: 'full',
    spanY: 1,
    minimumCards: 25,
    content: (t, _, products?: Product[]) => (
      <ProductCategoryCarousel
        productFeed={products || []}
        sliceRange={[20, -1]}
      />
    ),
    id: 'productCategoryCarousel',
    hideOnDevice: 'mobile',
  },
  {
    type: 'banner',
    classification: 'product-carousel',
    title: '',
    startRow: 3,
    startColumn: 1,
    spanX: 'full',
    spanY: 1,
    minimumCards: 25,
    content: () => (
      <RecentlyViewedProductsCarousel
        productCardType="simple"
      />
    ),
    hideOnDevice: 'desktop',
  },

  // All single column banners
  {
    type: 'banner-tile-center',
    classification: 'marketing-card',
    title: '',
    startRow: 7,
    startColumn: 'right-most',
    spanX: 1,
    spanY: 1,
    minimumCards: 9,
    content: () => (
      <ChatBanner />
    ),
  },
  {
    type: 'banner-tile-center',
    classification: 'marketing-card',
    title: 'products:Secure payments',
    graphics: '/graphics/secure-payment.svg',
    startRow: 11,
    startColumn: 'right-most',
    spanX: 1,
    spanY: 1,
    minimumCards: 26,
    content: (t) => (
      t('products:Pay by card or invoice, with net 30 terms available for business customers')
    ),
  },

  {
    type: 'banner-tile-left',
    classification: 'marketing-card',
    title: 'Find products for your use case',
    startRow: 5,
    startColumn: 0,
    spanX: 1,
    spanY: 1,
    minimumCards: 26,
    content: () => <UseCaseTagList />,
    bordered: false,
    className: styles['use-case-banner'],
  },
]

export default banners
